(ns iris.login.events
  (:require
   [re-frame.core :as re-frame]
   [iris.events :as events]
   [ajax.core :as ajax]
   [iris.utils :as utils]
   [iris.localstorage :as localstorage]
   [day8.re-frame.async-flow-fx :as async-flow-fx]
   [iris.routes :as routes]
   [clojure.string :as str]
   [iris.cookie :as cookie]
   [goog.crypt.base64 :as b64]
   [iris.globals :as globals]
   [iris.firebase :as firebase]))

(re-frame/reg-event-db
 ::set-login-error-message
 (fn [db [_ msg]]
   (assoc-in db [:login :error-message] msg)))

(re-frame/reg-event-db
 ::login-reset-needed
 (fn [db [_ val]]
   (println "SHOULD BE SETTING LOGGIN RESEST NEEDED")
   (assoc-in db [:login :reset-needed] val)))


(defn get-jwt-cookie []
  (or
   (cookie/get-cookie globals/AUT_JWT_COOKIE_NAME)
   (cookie/get-cookie globals/JWT_COOKIE_NAME)))


(defn get-fbjwt-cookie []
  (when-let [fbjwt (cookie/get-cookie globals/FBJWT_COOKIE_NAME)]
    (b64/decodeString fbjwt)))


;; cookie versions
;; (defn get-jwt []
;;   (cookie/get-cookie "jwt"))


;; (defn get-fbjwt []
;;   (when-let [fbjwt (cookie/get-cookie "fbjwt")]
;;     (b64/decodeString fbjwt)))


;; cookie version
;; (defn get-login_redirect []
;;   (or (cookie/get-cookie "login_redirect") "/new/posts"))

;; (defn get-login_redirect []
;;   (or @globals/login_redirect "/posts"))


(defn get-login_redirect []
  (if (or (empty? @globals/login_redirect) (= @globals/login_redirect "/login"))
    "/posts"
    @globals/login_redirect))



;; (defn get-login_redirect
;;   ([] (get-login_redirect {:remove false}))
;;   ([options]
;;    (println "get-login_redirect here with options" options)
;;    (if-let [path (cookie/get-cookie "login_redirect")]
;;                (do
;;                  (when (true? (:remove options))
;;                    (cookie/remove-cookie "login_redirect"))
;;                  path)
;;                "/new/posts")))

(defn get-jwt-payload [jwt]
  (js->clj (.parse js/JSON (b64/decodeString (second (str/split jwt #"\.")))) :keywordize-keys true))


(defn get-exp-time-left [exp]
  (let [now (/ (.now js/Date) 1000)]
    (int (- exp now))))


(defn jwt-valid? [jwt]
  (when-not (empty? jwt)
    (let [payload (get-jwt-payload jwt)
          exptl (get-exp-time-left (:exp payload))
          tier (:env payload)
          jwt-token-alive? (> exptl 0)
          has-access-priv? (some #(= % "iris") (:adminuis payload))]
      (cond
        (and has-access-priv? jwt-token-alive?)
        true
        (not has-access-priv?)
        (do
          (re-frame/dispatch [::set-login-error-message (str "You do not have access to Iris (" tier "). Please contact your administrator.")])
          false)
        (not jwt-token-alive?)
        (do
          (re-frame/dispatch [::set-login-error-message "Your login session has expired. Please log in again."])
          false)))))


(defn fbjwt-valid? [jwt]
  (when-not (empty? jwt)
    (let [payload (get-jwt-payload jwt)
          exptl (get-exp-time-left (:exp payload))]
      (> exptl 0))))


;; cookie versions
;; (defn fbjwt-logged-in? []
;;   (when-let [fbjwt (get-fbjwt)]
;;     (when (fbjwt-valid? fbjwt)
;;       fbjwt)))


;; (defn jwt-logged-in? []
;;   (when-let [jwt (get-jwt)]
;;     (when (jwt-valid? jwt)
;;       jwt)))

;; TODO: if logged out, firebase instance should be cleaned up

;; WORKS! non cookie version
;; (defn fbjwt-logged-in? []
;;   (when-let [fbjwt @globals/fbjwt]
;;     (when (fbjwt-valid? fbjwt)
;;       fbjwt)))

;; WORKS! non cookie version
;; (defn jwt-logged-in? []
;;   (when-let [jwt @globals/jwt]
;;     (when (jwt-valid? jwt)
;;       jwt)))


(defn fbjwt-logged-in? []
  (if-let [fbjwt @globals/fbjwt]
    (when (fbjwt-valid? fbjwt)
      fbjwt)
    (when-let [fbjwt (get-fbjwt-cookie)]
      (when (fbjwt-valid? fbjwt)
        (reset! globals/fbjwt fbjwt)
        (reset! globals/fbjwt-payload (get-jwt-payload fbjwt))
        fbjwt))))

(defn jwt-logged-in? []
  (if-let [jwt @globals/jwt]
    (when (jwt-valid? jwt)
      jwt)
    (when-let [jwt (get-jwt-cookie)]
      (when (jwt-valid? jwt)
        (reset! globals/jwt jwt)
        (let [jwt-payload (get-jwt-payload jwt)]
          (reset! globals/jwt-payload jwt-payload)
          (re-frame/dispatch [::events/set-jwt-payload jwt-payload]))
        jwt))))




(defn logged-in? []
  (when-let [jwt (jwt-logged-in?)]
    (when-not (fbjwt-logged-in?)
      (re-frame/dispatch [::get-firebase-jwt jwt]))
    true))


(defn linger? []
  (or @globals/linger
      (when-let [jwt (get-jwt-cookie)]
        (when (jwt-valid? jwt)
          (reset! globals/linger true)
          true))))


;; (re-frame/reg-fx
;;  :set-js-global-jwt
;;  (fn [val]
;;    (set! js/jwt val)))


;; (re-frame/reg-fx
;;  :set-js-global-firebase-jwt
;;  (fn [val]
;;    (set! js/firebaseJwt val)))



(re-frame/reg-fx
 :set-globals-linger
 (fn [val]
   (reset! globals/linger val)))

(re-frame/reg-fx
 :set-globals-jwt
 (fn [val]
   (reset! globals/jwt val)))

(re-frame/reg-fx
 :set-globals-fbjwt
 (fn [val]
   (reset! globals/fbjwt val)))

(re-frame/reg-fx
 :set-globals-login_redirect
 (fn [val]
   (reset! globals/login_redirect val)))

(re-frame/reg-fx
 :set-globals-jwt-payload
 (fn [val]
   (reset! globals/jwt-payload val)))

(re-frame/reg-fx
 :set-globals-fbjwt-payload
 (fn [val]
   (reset! globals/fbjwt-payload val)))

;; Cookie version
;; (re-frame/reg-event-fx
;;  ::get-jwt-success
;;  (fn [{:keys [db]} [_ data]]
;;    (if-not (empty? data)
;;      (let [payload (get-jwt-payload data)
;;            exptl (get-exp-time-left (:exp payload))]
;;        {:cookie/remove {:name "jwt"}
;;         :cookie/set {:name "jwt"
;;                      :value data
;;                      :max-age exptl
;;                      :path "/"}
;;         :set-js-global-jwt data
;;         :db (assoc-in db [:login :message] nil)})
;;      {})))




(re-frame/reg-fx
 :set-jwt-cookie
 (fn [data]
  ;;  (if (true? @globals/linger)
   (if (linger?)
     (let [payload (get-jwt-payload data)
           exptl (get-exp-time-left (:exp payload))]
       (cookie/remove-cookie globals/JWT_COOKIE_NAME "/")
       (cookie/set-cookie globals/JWT_COOKIE_NAME data exptl "/"))
     (cookie/remove-cookie globals/JWT_COOKIE_NAME "/"))))





;; cookie version
;; (re-frame/reg-event-fx
;;  ::get-firebase-jwt-success
;;  (fn [{:keys [db]} [_ data]]
;;    (if-not (empty? data)
;;      (let [payload (get-jwt-payload data)
;;            exptl (get-exp-time-left (:exp payload))]
;;        {:cookie/remove {:name "fbjwt"}
;;         :cookie/set {:name "fbjwt"
;;                      :value (b64/encodeString data)
;;                      :max-age exptl
;;                      :path "/"}
;;         :set-js-global-firebase-jwt data})
;;      {})))


(re-frame/reg-fx
 :set-fbjwt-cookie
 (fn [data]
  ;;  (if (true? @globals/linger)
   (if (linger?)
     (let [payload (get-jwt-payload data)
           exptl (get-exp-time-left (:exp payload))]
       (cookie/remove-cookie globals/FBJWT_COOKIE_NAME "/")
       (cookie/set-cookie globals/FBJWT_COOKIE_NAME (b64/encodeString data) exptl "/"))
     (cookie/remove-cookie globals/FBJWT_COOKIE_NAME "/"))))


(re-frame/reg-event-fx
 ::get-firebase-jwt-success
 (fn [{:keys [db]} [_ data]]
   (if-let [fbjwt (not-empty (get-in data [:result :data]))]
     {:set-globals-fbjwt fbjwt
      :set-globals-fbjwt-payload (get-jwt-payload fbjwt)
      :set-fbjwt-cookie fbjwt
      :db (-> db
              (assoc-in [:login :error-message] nil)
              (assoc-in [:loading] false))}
     {})))

(re-frame/reg-event-db
 ::get-firebase-jwt-failure
 (fn [db]
   (-> db
       (assoc-in [:login :error-message] "Get FBJWT failure!")
       (assoc-in [:loading] false))))


;; (re-frame/reg-event-fx
;;  ::get-firebase-jwt
;;  (fn [{:keys [db]} [_ jwt]]
;;    {:http-xhrio {:method :get
;;                  :uri (str (utils/get-service-url "apollo") "/firebase-jwt")
;;                  :timeout 8000
;;                  :headers [:Authorization (str "Bearer " jwt)]
;;                  :response-format (ajax/text-response-format)
;;                  :on-success      [::get-firebase-jwt-success]
;;                  :on-failure      [::get-firebase-jwt-failure]}
;;     :db (-> db
;;             (assoc-in [:loading] true))}))

(re-frame/reg-event-fx
 ::get-firebase-jwt
 (fn [{:keys [db]} [_ jwt]]
   {:http-xhrio {:method :post
                ;;  :uri (str (utils/get-service-url "aut") "/rpc")
                ;;  :uri js/autURL
                 :uri js/hermesURL
                 :body (utils/clj->json
                        {:jsonrpc "2.0"
                         :id 0
                        ;;  :method "getFirebaseToken"
                         :method "FirebaseToken.Get"})
                 :timeout 60000
                 :headers [:Authorization (str "Bearer " jwt)]
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [::get-firebase-jwt-success]
                 :on-failure      [::get-firebase-jwt-failure]}
    :db (-> db
            (assoc-in [:loading] true))}))



(re-frame/reg-event-fx
 ::login-redirect
 (fn [e [_]]
   (let [path (get-login_redirect)]
     (re-frame/dispatch [::events/route-to path])
    ;;  {:cookie/remove {:name "login_redirect"}}
     {:set-globals-login_redirect nil})))



;; URL: aut.rkdev.org/rpc
;; Login methods: "getToken", "getTokenAndClaims"
;; Change password method: "changePassword"

;; changePassword data fields: username, oldPassword, newPassword
;; getToken, getTokenAndClaims fields: username, password



(re-frame/reg-event-fx
 ::get-token-and-claims-success
 (fn [{:keys [db]} [_ res]]
   (let [token (get-in res [:result :data :token])]
     (when-not (empty? token)
       (let [jwt-payload (get-jwt-payload token)]
         {:set-globals-jwt token
          :set-globals-jwt-payload jwt-payload
          :set-jwt-cookie token
          ;; Added the right way to dispatch the add-msg event from effects map but realized that it would duplicate the message since it's being added in core.cljs under jwt-observer. Anyways, keeping it below. 
          ;; :dispatch [::events/add-msg {:info (str "Logged in Iris, env "
          ;;                                         (:env jwt-payload)
          ;;                                         ", tier " js/window.tier
          ;;                                         ", as " (:uid jwt-payload))}]
          :db (-> db
                  (assoc-in [:jwt-payload] jwt-payload)
                  (assoc-in [:login :error-message] nil)
                  (assoc-in [:login :success-message] nil)
                  (assoc-in [:loading] false))})))))



;; NOTE: started using the actual error message from backend so the messages are not hardcoded here
;; (defn get-token-and-claims-failure-message [error-code]
;;   (cond (= error-code -32011)
;;         "Login failed: user must change password first!"
;;         (= error-code -32010)
;;         "Login failure!"))

(re-frame/reg-event-db
 ::get-token-and-claims-failure
 (fn [db [_ res]]
   (println "res" res)
   (let [
        ;;  error-code (get-in res [:response :error :code])
        ;;  error-message (get-token-and-claims-failure-message error-code)
         curr-error-message (get-in db [:login :error-message])
         new-error-message (get-in res [:error :message])
         ]
     (-> db
         (assoc-in [:login :error-message] (str curr-error-message " " new-error-message))
         (assoc-in [:loading] false)))))


(re-frame/reg-event-fx
 ::get-token-and-claims
 (fn [{:keys [db]} [_ username password]]
    {:http-xhrio {:method :post
                  ;; :uri (str (utils/get-service-url "aut") "/rpc")
                  :uri js/autURL
                  :body (utils/clj->json
                         {:jsonrpc "2.0"
                          :id 0
                          ;; :method "getTokenAndClaims"
                          :method "getToken"
                          :params {:options {:debug false}
                                   :data {:username username :password password}}})
                  :timeout 60000
                  :headers {;;  "Authorization" (str "Bearer " jwt)
                            "Content-Type" "application/json; charset=UTF-8"}
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success [::get-token-and-claims-success]
                  :on-failure [::get-token-and-claims-failure]}
     :db (-> db
             (assoc-in [:loading] true))}))






(re-frame/reg-event-fx
 ::change-password-success
 (fn [{:keys [db]} [_ res]]


   (if-let [error-message (get-in res [:error :message])]
     {:db (-> db
              (assoc-in [:login :error-message] error-message)
              (assoc-in [:loading] false))}
     {:db (-> db
              (assoc-in [:login :reset-needed] false)
              (assoc-in [:login :error-message] nil)
              (assoc-in [:login :success-message] "Password changed successfully!")
              (assoc-in [:loading] false))})


  ;;  (if (true? (get-in res [:result :data :success]))
  ;;    {:db (-> db
  ;;             (assoc-in [:login :reset-needed] false)
  ;;             (assoc-in [:login :error-message] nil)
  ;;             (assoc-in [:login :success-message] "Password changed successfully!")
  ;;             (assoc-in [:loading] false))}
  ;;    {})
   ))


(re-frame/reg-event-db
 ::change-password-failure
 (fn [db [_ res]]
   (let [error-code (get-in res [:response :error :code])
         error-message (get-in res [:response :error :message])]
     (-> db
         (assoc-in [:login :error-message] error-message)
         (assoc-in [:loading] false)))))


(re-frame/reg-event-fx
 ::change-password
 (fn [{:keys [db]} [_ username old-password new-password]]
   {:http-xhrio {:method :post
                ;;  :uri (str (utils/get-service-url "aut") "/rpc")
                 :uri js/autURL
                 :body (utils/clj->json
                        {:jsonrpc "2.0"
                         :id 0
                         :method "changePassword"
                         :params {:options {:debug false}
                                  :data {:username username
                                         :oldPassword old-password
                                         :newPassword new-password}}})
                 :timeout 60000
                 :headers {;;  "Authorization" (str "Bearer " jwt)
                           "Content-Type" "application/json; charset=UTF-8"}
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success [::change-password-success]
                 :on-failure [::change-password-failure]}
    :db (-> db
            (assoc-in [:loading] true))}))


(defn login-flow
  [username password]
  {:first-dispatch [::get-token-and-claims username password]
   :rules [{:when :seen?
            :events ::get-token-and-claims-failure
            :dispatch-fn (fn [[e res]]
                           (let [error-code (get-in res [:error :code])]
                             (when (= error-code 22)
                               [[::login-reset-needed true]])))}
           {:when :seen?
            :events ::get-token-and-claims-success
            :dispatch-fn (fn [[e res]]
                           (let [jwt (get-in res [:result :data :token])]
                             (if (jwt-valid? jwt)
                               [[::get-firebase-jwt jwt]]
                               [[::get-token-and-claims-failure res]])))}
           {:when :seen?
            :events ::get-token-and-claims-failure
            :halt? true}
           {:when :seen?
            :events ::get-firebase-jwt-success
            :dispatch [::login-redirect]
            :halt? true}]})


(re-frame/reg-event-fx
 ::login
 (fn [e [_ username password linger]]
   {:set-globals-linger linger
    :async-flow (login-flow username password)}))


(re-frame/reg-event-fx
 ::reset-password
 (fn [e [_ username password new-password new-password-2]]
   {}))


(defn logout []
  (firebase/sign-out!)
  (cookie/remove-base-domain-cookie globals/AUT_JWT_COOKIE_NAME "/")
  (cookie/remove-cookie globals/JWT_COOKIE_NAME "/")
  (cookie/remove-cookie globals/FBJWT_COOKIE_NAME "/")
  (reset! globals/jwt nil)
  (reset! globals/fbjwt nil)
  (reset! globals/jwt-payload nil)
  (reset! globals/fbjwt-payload nil)
  (reset! globals/fb-user nil)
  (re-frame/dispatch [::events/set-fb-auth-state nil])
  ;; user gets redirected to aut login page upon "aut-logout-event" from rk-admin-top-bar
  ;; (re-frame/dispatch [::events/navigate :login])
  )